import * as Factory from 'factory.ts'
import faker from 'faker'

import { VendorTypes } from '@webapp/models/enums/Vendor'
import { PaymentTermMock } from './paymentTerm.factory'
import { ShippingMethodMock } from './shippingMethod.factory'
import { ShippingTermMock } from './shippingTerm.factory'
import {
  type PayCardVendor,
  type SimpleVendor,
  type Vendor,
  type VendorAttachment,
} from '../../models'

export const VendorMock = Factory.Sync.makeFactory<Vendor>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.company.companyName()),
  active: true,
  addressLineOne: Factory.each(() => faker.address.streetAddress()),
  addressLineTwo: Factory.each(() => faker.address.streetAddress()),
  postalCode: Factory.each(() => faker.address.zipCode()),
  city: Factory.each(() => faker.address.city()),
  state_province: Factory.each(() => faker.address.state()),
  country: Factory.each(() => faker.address.country()),
  phoneOne: Factory.each(() => faker.phone.phoneNumber()),
  phoneTwo: '',
  fax: '',
  email: [faker.internet.email()],
  comments: faker.lorem.sentence(),
  contact: faker.name.findName(),
  url: faker.internet.url(),
  external_id: '',
  dateModified: faker.date.past(10).toISOString(),
  currency: faker.random.number(),
  payment_term_ref: PaymentTermMock.build(),
  shipping_term_ref: ShippingTermMock.build(),
  payment_method_ref: null,
  shipping_method_ref: ShippingMethodMock.build(),
  payment_methods: [],
  tax: null,
  type: VendorTypes.PREFERRED,
  default_payment_method: null,
  creditcards: [],
  is_1099_eligible: null,
})

export const SimpleVendorMock = Factory.Sync.makeFactory<SimpleVendor>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.company.companyName()),
})

export const PayCardVendorMock = Factory.Sync.makeFactory<PayCardVendor>({
  category: faker.commerce.department(),
  city: Factory.each(() => faker.address.city()),
  country: faker.address.countryCode(),
  name: Factory.each(() => faker.company.companyName()),
  postal_code: faker.address.zipCode(),
  state: Factory.each(() => faker.address.stateAbbr()),
})

export const VendorAttachmentMock = Factory.Sync.makeFactory<VendorAttachment>({
  created_at: faker.date.past().toISOString(),
  file: Factory.each(() => `attachments_${faker.random.uuid()}`),
  mimetype: 'image/png',
  name: Factory.each(
    (index) => `attachment_${index}_${faker.system.commonFileName('png')}`
  ),
  uuid: Factory.each(() => faker.random.alphaNumeric(32)),
})
